import { interpolate, INTERPOLATE_REGEXP } from 'mk2/services/i18n';
import React from 'react';

interface Props {
    className?: string;
    parent?: string;
    i18nKey: string | string[];
    useDangerouslySetInnerHTML?: boolean;
    dangerouslySetInnerHTMLPartElement?: string;
    count?: number;
}

export type OwnProps = Props & {
    [name: string]: React.ReactNode;
};

class Interpolate extends React.PureComponent<OwnProps> {

    public static defaultProps = {
        parent: 'span',
        dangerouslySetInnerHTMLPartElement: 'span',
        useDangerouslySetInnerHTML: false,
    };

    public render() {
        const { parent, i18nKey, useDangerouslySetInnerHTML, dangerouslySetInnerHTMLPartElement, children, className, ...rest } = this.props;
        const element = parent || 'span';

        const message = interpolate(i18nKey, { count: rest.count });

        if (process.env.NODE_ENV !== 'production') {
            if (useDangerouslySetInnerHTML) {
                // Detect variables inside HTML tags
                const re = /<([^ >]+)[^>]*>.*?<\/\1>/g;
                let match;
                do {
                    match = re.exec(message);
                    if (match && INTERPOLATE_REGEXP.test(match[0])) {
                        throw new Error(`Interpolate: Cannot use 'useDangerouslySetInnerHTML' prop with key that contains HTML around variable. It will produce invalid HTML and break React with very strange error.`);
                    }
                } while (match);
            }
        }

        const parts = message.split(INTERPOLATE_REGEXP).reduce((acc, cur, index) => {
            let child;

            if (index % 2 === 0) {
                if (cur.length === 0) {
                    return acc;
                }

                child = useDangerouslySetInnerHTML
                    ? React.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: cur } })
                    : cur;
            } else {
                child = rest[cur];
            }

            acc.push(child);
            return acc;
        }, []);

        return React.createElement.apply(this, [ element, { className } ].concat(parts));
    }

}

export default Interpolate;
